import React, { useState, useEffect, useReducer } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { I18n } from "aws-amplify/utils";
import {
  Box,
  Typography,
  Grid,
  Paper,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import InfoIcon from "@mui/icons-material/Info";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useTemplateController } from "context";
import { get } from "aws-amplify/api";
import currentUserToken from "CurrentUserToken";
import ConfirmSuspendAlarmDialog from "./ConfirmSuspendAlarmDialog";
import Draggable from "react-draggable";

dayjs.extend(utc);
dayjs.extend(timezone);
//dayjs.tz.setDefault("Europe/Rome"); // Imposta il fuso orario per l'Italia

const reducer = (lastState, action) => {
    if (action.type === "DATA_RECEIVED") {
        const audit = action.value;
        if (Array.isArray(audit)) {
            audit.forEach((element) => {
            if (typeof element.timestamp === "number") {
                element.timestamp = dayjs(element.timestamp).format("YYYY-MM-DD HH:mm");
            }
        });
        return { audit: audit, fetched: true };
        }
    }
    return lastState;
};

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
        nodeRef={nodeRef}
        cancel={'[class*="MuiDialogContent-root"]'}
        >
        <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

function SuspendQuickAlarmDialog({
    open,
    onClose,
    onSave,
    alarm,
    setIsLocked,
    isLocked,
    setValueDuration,
    valueDuration,
}) {
    const [remark, setRemark] = useState("");
    const [calendarId, setCalendarId] = useState("");
    const [calendar, setCalendar] = useState("");
    const [endDate, setEndDate] = useState();
    const [confirmation, setConfirmation] = useState(false);

    useEffect(() => {
        if (open) {
            setRemark("");
            setIsLocked(false);
            setEndDate(dayjs().tz().format("YYYY-MM-DD HH:mm:ss"));
        }
    }, [open, setRemark, setValueDuration, setEndDate]);

    const handleSave = () => {
        const newEndDate = dayjs().add(valueDuration, "hour").tz().format("YYYY-MM-DD HH:mm:ss");
        setEndDate(newEndDate);
        const utcEndDate = dayjs(newEndDate).utc().format("YYYY-MM-DD HH:mm:ss");
        onSave(remark, utcEndDate, calendarId);
        onClose();
    };

    const [controller] = useTemplateController();
    const { darkMode } = controller;
    const [state, dispatch] = useReducer(reducer, {
        audit: [],
        fetched: false,
    });
    const data = alarm && alarm.length > 0 ? alarm[0] : {};

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperComponent={PaperComponent}>
        <DialogTitle style={{ cursor: 'move' }}>
            {I18n.get("Quick Suspend Alarm - ")}
            { alarm.length > 1 ? "Multiple Alarms Selected" : data.original_store + " - " + data.original_equipment + " - " + data.alarm_type_description }
            {" - " + valueDuration}
            { valueDuration === 1 ? I18n.get(" hour") : I18n.get(" hours")}
        </DialogTitle>
        <DialogContent>
            <Box
                display="flex"
                alignItems="center"
                bgcolor={darkMode ? "#27496d" : "lightblue"}
                p={2}
                borderRadius={1}
                mb={2}
            >
            <InfoIcon sx={{ mr: 1 }} />
            <Typography variant="body2">
                {I18n.get("This section allows you to quick suspend alarms for ") + valueDuration }
                { valueDuration === 1 ? I18n.get(" hour") : I18n.get(" hours") }
            </Typography>
            </Box>

            <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                <TextField
                    type="text"
                    autoComplete="on"
                    label={I18n.get("Note")}
                    fullWidth
                    multiline
                    rows={4}
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                />
                </Grid>
            </Grid>
            </Box>
        </DialogContent>
        <DialogActions style={{ cursor: 'move' }}>
            <Button onClick={onClose}>{I18n.get("Cancel")}</Button>
            <Button onClick={handleSave}>{I18n.get("Save")}</Button>
        </DialogActions>
        <ConfirmSuspendAlarmDialog
            open={confirmation}
            onClose={() => setConfirmation(false)}
            onSave={handleSave}
            onCancel={() => setConfirmation(false)}
        />
        </Dialog>
    );
}

export default SuspendQuickAlarmDialog;